import { IconProduct3DTour16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';

export const Features = () => {
  return (
    <div className={style['container']}>
      <div className={style['feature']}>
        <IconProduct3DTour16 color="icon-inverted-default" />
      </div>
    </div>
  );
};
